module.exports = __webpack_public_path__ + "static/media/refresh-icon.fc7d3ae5.svg";